import { Injectable } from '@angular/core';
import { AuthData } from '@app/models';
import { appValues } from '@app/shared';

@Injectable()
export class LocalStorageService {

  constructor() { }

  getAuthData(): AuthData | null {
    try {
      const item = localStorage.getItem(appValues.authDataKey);

      return item ? (JSON.parse(item) as AuthData) : null;
    } catch (err) {
      return null;
    }
  }

  setAuthData(value: AuthData) {
    localStorage.setItem(appValues.authDataKey, JSON.stringify(value));
  }

  getItem(key: string) {
    try {
      const item = localStorage.getItem(key);

      return item ? JSON.parse(item) : null;
    } catch (err) {
      return null;
    }
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clearStorage(): void {
    localStorage.clear();
  }

}
